import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.awk = bracketIndenting({
	line: "#",
})
